export const SHARE_CREDIT_APP_QR_CODE_CONTENT = {
    heading: 'Scan QR Code',
    description: (buyerFirstName: string) => `${buyerFirstName} scans to enter their information on their phone.`,
    unavailableMessage: 'QR code temporarily unavailable.',
    imageLabel: 'QR code to open the credit application'
};

export const SHARE_CREDIT_APP_QR_CODE_SIZE = 107;
